import { useEffect, useState, ReactNode } from "react";

interface MenuFriendlyIframeProps {
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const MenuFriendlyIframe: React.FC<MenuFriendlyIframeProps> = ({
  children,
  className,
  style,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  useEffect(() => {
    const checkMenuState = () => {
      const popoverElements = document.querySelectorAll(".ant-popover-open");
      const hasOpenPopover = popoverElements.length > 0;
      setIsMenuOpen(hasOpenPopover);
    };

    checkMenuState();

    const observer = new MutationObserver(checkMenuState);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  const handleOverlayClick = () => {
    console.log("[MenuFriendlyIframe] Overlay click detected - menu is open");
    const clickEvent = new MouseEvent("mousedown", {
      bubbles: true,
      cancelable: true,
      view: window,
    });
    console.log(
      "[MenuFriendlyIframe] Dispatching mousedown event to close menus"
    );
    document.body.dispatchEvent(clickEvent);
  };

  return (
    <div className={className} style={{ position: "relative", ...style }}>
      {isMenuOpen && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 1,
            backgroundColor: "transparent",
            pointerEvents: "auto",
          }}
          onClick={handleOverlayClick}
        />
      )}
      {children}
    </div>
  );
};

export default MenuFriendlyIframe;
